module.exports = __webpack_public_path__ + "static/img/clickin40.c88ce103.png";